import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';
import { IPage } from 'src/app/shared/utils/page';
import { NgIf, NgClass, NgFor, NgStyle, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ShareContentComponent } from '../../share-content/share-content.component';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-videos-subscription',
    templateUrl: './videos-subscription.component.html',
    styleUrls: ['./videos-subscription.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink, FormsModule, NgClass, NgFor, NgStyle, NgxPaginationModule, ShareContentComponent, DatePipe, SearchFilterPipe, HighlightSearchPipe]
})
export class VideosSubscriptionComponent implements OnInit {

  public screenWidth: any;
  public serviceError = 'Loading data. Please wait...';
  public channelSubscriptions: any[];
  private subscription: ISubscription[];
  public isSubscribed = true;
  public videosList;
  public channelVideos; 
  public shareContentObject = {};
  APP_SETTINGS:any;
  username: string;
  public dateFormat: string;
  
  public currentPage = 0;
  public pageSize = 5;
  public totalPages = 0;
  public totalElements = 0;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  constructor(
    private utilityService: UtilityService,
    private videoService: VideosService,
    private authService: AuthService,
    private spinnerService: SpinnerService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.loadSubscribedChannels();
  }

  loadSubscribedChannels() {
    console.log('Loading subscribed channels with videos for user: ' + this.username);
    this.spinnerService.show('bmwSpinner');
    this.videoService.getSubscribedChannelsWithVideos(this.username, this.currentPage + 1, this.pageSize).subscribe(
      (data: IPage<any>) => {
        this.channelSubscriptions = data.content;
        this.totalPages = data.totalPages;
        this.totalElements = data.totalElements;
        this.spinnerService.hide('bmwSpinner');
      },
      error => {
        this.spinnerService.hide('bmwSpinner');
      }
    );
    //this.spinnerService.hide('bmwSpinner');
    this.subscription = [];
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }

  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber:videoDisplayNumber
    };
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  goToPage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.currentPage = page;
      this.loadSubscribedChannels();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.goToPage(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 0) {
      this.goToPage(this.currentPage - 1);
    }
  }
}
